import aliOSS from 'ali-oss'
import { ALLOW_IMG_FILE_TYPE, ALLOW_IMG_FILE_MAX_SIZE, LOAD_STATUS } from '../js/constant';
import { getFileUploadTokenInfo, imgFileInfoUpload } from '../js/request';
import MessageBox from "../../../../components/message-box";

/**
 * 获取用户定位
 */
export function getUserCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(positions => {
        if(positions) {
          resolve(positions)
        } else {
          reject('获取定位权限失败')
        }
      });
    } else {
      reject('暂不支持获取定位功能')
    }
  })
}

export function noop() {}

/**
 * 上传至阿里云服务
 */
export const upload2AliCloud = async (file) => {
  console.log(
    '~ file: index.tsx ~ upload2AliCloud ~ e',
    file?.name,
    file?.type,
    file?.size
  )

  const indexExt = file?.name?.lastIndexOf('.');
  if(!file || indexExt < 0) {
    MessageBox.toast(`文件格式不支持，请上传 ${ALLOW_IMG_FILE_TYPE} 格式的文件`, { timeout: 3000 });
    return Promise.reject();
  }
  if (indexExt > -1) {
    const ext = file?.name?.substr(indexExt + 1)
    if (!ALLOW_IMG_FILE_TYPE.includes(ext)) {
      MessageBox.toast(`文件格式不支持，请上传 ${ALLOW_IMG_FILE_TYPE} 格式的文件`, { timeout: 3000 });
      return Promise.reject();
    }
  }

  if (file?.size > ALLOW_IMG_FILE_MAX_SIZE) {
    MessageBox.toast('单张照片大小不能超过10M，请重新选择上传~', { timeout: 3000 });
    return Promise.reject();
  }

  // 获取 oss token
  const ossToken: any = await getFileUploadTokenInfo({fileName: file.name});
  return new Promise(async (resolve, reject) => {
    if (ossToken) {
      const { path, accessKeyId, accessKeySecret, securityToken, bucket, url: fileUrl } = ossToken;
      const ossClient = await new aliOSS({
        accessKeyId,
        accessKeySecret,
        stsToken: securityToken,
        region: 'oss-cn-hangzhou',
        bucket,
        secure: true,
      })
  
      const uploadRes: any = await ossClient.multipartUpload(path, file)
  
      if (uploadRes?.res?.statusCode === 200) {
        resolve({
          ...ossToken,
          fileName: file.name,
          url: addParamsToUrl(fileUrl, {
            'x-oss-process': 'image/auto-orient,1'
          }),
        })
      } else {
        reject('上传失败')
      }
    } else {
      reject('上传失败')
    }
  });
}

export const handleBeforeUpload = async (file: any, options: any) => {
  console.log(
    '~ file: index.tsx ~ line 172 ~ handleBeforeUpload ~ e',
    file?.name,
    file?.type,
    file?.size
  )

  if(!file) {
    MessageBox.toast(`文件格式不支持，请上传 ${ALLOW_IMG_FILE_TYPE} 格式的文件`, { timeout: 3000 });
    return Promise.reject();
  }

  const fileName = file.name;
  return upload2AliCloud(file)
    .then((ret: any) => {
      const { fileId, path, url: fileUrl } = ret;
      // 将数据更新至服务端
      imgFileInfoUpload(
        {
          ...options,
          fileId,
          fileName,
          path,
          url: fileUrl
        }
      )
      return Promise.resolve(ret);
    })
    .catch(err => {
      return Promise.reject(err);
    })
}

// 检查是否为 Promise 对象
function isPromise(obj) {
  return (
    !!obj &&
    (typeof obj === 'object' || typeof obj === 'function') &&
    typeof obj.then === 'function'
  );
}

// 包装 dispatch
export function wrapperDispatch(dispatch) {
  return function fn(action) {
    if (isPromise(action.payload)) {
      dispatch({
        ...action,
        loadStatus: LOAD_STATUS.PENDING
      });
      action.payload.then(res => {
        dispatch({
          ...action,
          loadStatus: LOAD_STATUS.SUCCESS,
          payload: res || {}
        });
      }).catch(err => {
        console.error('dispatch request fail', err);
        dispatch({
          ...action,
          loadStatus: LOAD_STATUS.FAIL
        });
      });
    } else {
      dispatch(action);
    }
  };
}

// 格式化电话号码
export function formatPhoneNumber(numberStr, replaceChar = ' ') {
  const len = numberStr.length;
  if(len === 11) {
    return numberStr.replace(/\B(?=(?:\d{4})+$)/g, replaceChar)
  }

  if(len === 10) {
    return numberStr.replace(/^(.{3})(.{3})(.{4})$/g, `$1${replaceChar}$2${replaceChar}$3`)
  }
  return numberStr;
}

// 检查是否为空对象
export function isObjectEmpty(obj: {}) {
  return Object.keys(obj).length === 0
}

// 添加 url 参数
export function addParamsToUrl(url, params) {
  if (typeof params !== 'object' || isObjectEmpty(params)) return url;
  let paramsStr = url.indexOf('?') !== -1 ? '' : '?';
  Object.keys(params).forEach(key => {
    paramsStr += `&${key}=${params[key]}`
  });

  return url.lastIndexOf('&') !== url.length - 1 ? url + paramsStr : url + paramsStr.substr(1);
}

// 保留2位数字
const paddingLeft = num => `0${num}`.slice(-2);

// 时间戳格式化
export function formatDateTime(timeStamp) {
  if(!timeStamp) return '';
  const d = new Date(timeStamp);
  return `${d.getFullYear()}/${paddingLeft(d.getMonth() + 1)}/${paddingLeft(d.getDate())} ${paddingLeft(d.getHours())}:${paddingLeft(d.getMinutes())}`
}
